import { NotationType } from './NotationType';

export const notationTypes = [
  { value: NotationType.Update, label: 'Updates' },
  { value: 'Alert:Open', label: 'Open Alerts' },
  { value: 'Alert:Lowered', label: 'Lowered Alerts' },
  { value: NotationType.Encouragement, label: 'Encouragements' },
  { value: NotationType.DataInsight, label: 'Data Insights' },
];

export type CreatedOnTypes =
  | 'all'
  | 'sevenDays'
  | 'thirtyDays'
  | 'sixMonths'
  | 'custom';

export type PeopleTypes = 'me' | 'other' | 'unassigned' | 'none';
